// @flow
import CompoundVideoStreamer from '../components/player/VideoStreamer/CompoundVideoStreamer/CompoundVideoStreamer';
export default CompoundVideoStreamer;
